import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './SnackBar.css';

// const getIcon = type => {
//   switch (type && type.toLowerCase()) {
//     case 'success':
//       return {
//         icon: 'mdi mdi-check-circle-outline',
//         color: 'var(--accent-success)',
//         textColor: 'var(--bg-panel)',
//       };
//     case 'warning':
//       return {
//         icon: 'mdi mdi-alert-outline',
//         color: 'var(--accent-warning)',
//         textColor: 'var(--text-bold)',
//       };
//     case 'danger':
//       return {
//         icon: 'mdi mdi-close-circle-outline',
//         color: 'var(--accent-danger)',
//         textColor: 'var(--bg-panel)',
//       };
//     default:
//       return {
//         icon: 'mdi mdi-information-outline',
//         color: 'var(--new-primary)',
//         textColor: 'var(--bg-panel)',
//       };
//   }
// };

const getIcon = type => {
  switch (type && type.toLowerCase()) {
    case 'success':
      return {
        icon: 'mdi mdi-check-circle-outline',
        color: '0, 209, 178',
        textColor: '255, 255, 255',
      };
    case 'warning':
      return {
        icon: 'mdi mdi-alert-outline',
        color: '255, 246, 161',
        textColor: 'var(--text-bold)',
      };
    case 'danger':
      return {
        icon: 'mdi mdi-close-circle-outline',
        color: '255, 56, 96',
        textColor: '255, 255, 255',
      };
    default:
      return {
        icon: 'mdi mdi-information-outline',
        color: '78, 77, 174',
        textColor: '255, 255, 255',
      };
  }
};

class SnackBar extends React.Component {
  static propTypes = {
    showOnce: PropTypes.bool,
    show: PropTypes.bool,
    message: PropTypes.string,
    onEnd: PropTypes.func,
    type: PropTypes.string,
  };

  static defaultProps = {
    show: false,
    showOnce: false,
    message: null,
    onEnd: () => {},
    type: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      enter: false,
      exit: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.show && newProps.show) {
      this.show(newProps.message);
      return;
    }

    if (this.props.show && !newProps.show) {
      this.hide(newProps.message);
      return;
    }

    if (!this.props.showOnce && newProps.showOnce) {
      this.showOnce(newProps.message);
    }
  }

  show = message => {
    if (!message || message === '') {
      return;
    }

    this.setState({ enter: true, exit: false });
  };

  hide = message => {
    if (!message || message === '') {
      this.setState({ enter: false, exit: false }, this.props.onEnd);
      return;
    }

    const endAnimation = () =>
      this.setState({ enter: false, exit: false }, this.props.onEnd);
    const onExit = () => setTimeout(endAnimation, 500);
    this.setState({ enter: false, exit: true }, onExit);
  };

  showOnce = message => {
    if (!message || message === '') {
      return;
    }

    const endAnimation = () =>
      this.setState({ enter: false, exit: false }, this.props.onEnd);
    const onExit = () => setTimeout(endAnimation, 500);
    const startExit = () => this.setState({ enter: false, exit: true }, onExit);
    const onEnter = () => setTimeout(startExit, 3000);
    this.setState({ enter: true, exit: false }, onEnter);
  };

  render() {
    const { message, type } = this.props;

    const { enter, exit } = this.state;

    return (
      <div
        className={s.root}
        style={{
          width: !enter && !exit ? 0 : 'auto',
          height: !enter && !exit ? 0 : 'auto',
        }}
      >
        <div
          className={cx(s.snackbar, { [s.fadeIn]: enter, [s.fadeOut]: exit })}
        >
          <div
            className={s.message}
            style={{
              backgroundColor: `rgb(${getIcon(type).color})`,
              color: `rgb(${getIcon(type).textColor})`,
            }}
          >
            <p>{message || 'akjshdkjashdkjahsd kjahsdkjad jakshd aksd'}</p>
          </div>
          <div className={s.icon}>
            <span
              className={getIcon(type).icon}
              style={{ color: `rgb(${getIcon(type).color})` }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SnackBar);



// WEBPACK FOOTER //
// ./src/components/SnackBar/SnackBar.js